import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ClientsDataService} from '../clients-data.service';

@Component({
    selector: 'app-view-client',
    templateUrl: './view-client.component.html',
    styleUrls: ['./view-client.component.scss']
})

export class ViewClientComponent implements OnInit {

    constructor(private router: Router,
                private route: ActivatedRoute,
                private clientService: ClientsDataService) {
    }

    clientId: string;
    clientData: any = [];
    clientLogo: string;
    companyFacebook: string;
    companyInstagram: string;
    companyLinkedIn: string;
    companyTikTok: string;
    companyYouTube: string;
    companyWebsite: string;
    jobs: any =[];

    ngOnInit() {

        this.route.params.subscribe(params => {
            this.clientId = params['id'];
        });

        this.clientService.getCompanyById(this.clientId).subscribe(company => {
            this.clientData = company;
            this.clientLogo = this.clientData.companyLogo.link;
            this.companyFacebook = this.clientData.companySocialMedia['companyFacebook'];
            this.companyInstagram = this.clientData.companySocialMedia['companyInstagram'];
            this.companyLinkedIn = this.clientData.companySocialMedia['companyLinkedIn'];
            this.companyTikTok = this.clientData.companySocialMedia['companyTikTok'];
            this.companyYouTube = this.clientData.companySocialMedia['companyYouTube'];
            this.companyWebsite = this.clientData.companySocialMedia['companyWebsite'];
        })

        // Get all jobs from company
        this.clientService.getAllJobsFromCompany(this.clientId).subscribe(jobs => {
            this.jobs = jobs;
        }, error => {
        });
    }

}
